/*!
 * JavaScript for GAYL Online site
 * Give as you Live Ltd
 */

// Import modules
const Competition = require('Scripts/gayl/competition');
const FormUtils   = require('Scripts/common/form-utils');
const Loader      = require('Scripts/common/loader');

// Define groups of modules - the group name is set in your template ($jsModuleGroup). 
// This is just a nicer way to load JS on specific pages without looking at the path/params
// To initiate a group, use the #module macro. E.g. #module("my-group") would add 'my-group' from the groups below.
const moduleGroups = {
	// Available on specific pages
	'competition': [Competition],
    'form-utils':  [FormUtils],
};

Loader.load(moduleGroups);